import React, { useState } from 'react';

import Button from '../../Button/Button';
import CirclesImage from '../../../images/sign-up-circles.svg';
import Grid from '../../Layouts/Grids/GeneralGrid/GeneralGrid';
import GridItem from '../../Layouts/Grids/GeneralGrid/GeneralGridItem';
import RecaptchaAttribution from '../RecaptchaAttribution/RecaptchaAttribution';
import SiteLink from '../../Link/SiteLink';
import TextField from '../TextField';
import * as styles from './NewsletterSignupForm.module.scss';
import useHubspotProxyForm from '../../../helpers/useHubspotProxyForm';

const NewsletterSignupForm = () => {
  const [email, setEmail] = useState('');
  const [honeypot, setHoneypot] = useState('');
  const [trapped, setTrapped] = useState(false);
  const {
    containerRef, targetId, submitting, submitted, error, submit,
  } = useHubspotProxyForm({ formId: process.env.GATSBY_HUBSPOT_NEWSLETTER_FORM_ID });

  const showSuccess = submitted || trapped;

  const handleSubmit = (event) => {
    event.preventDefault();

    // Only bots fill the hidden field. Fake the success state so they don't learn they were caught.
    if (honeypot) {
      setTrapped(true);
      setEmail('');
      return;
    }

    submit({ email });
  };

  return (
    <section className={styles.newsletterSignup}>
      <h2>Sign up to our email newsletter to get updates about our events, work and research</h2>

      <div className={styles.formContainer}>
        <div className={styles.formBody}>
          <form id="newsletterSignupForm" onSubmit={handleSubmit}>
            {!showSuccess && (
              <>
                <input
                  className={styles.honeypot}
                  type="text"
                  name="hp_a3f9"
                  value={honeypot}
                  onChange={(event) => setHoneypot(event.target.value)}
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  data-lpignore="true"
                  data-1p-ignore="true"
                  data-bwignore="true"
                  data-form-type="other"
                />
                <Grid align="flex-end">
                  <GridItem spanMd="6" spanXLg="4">
                    <TextField
                      id="newsletterEmail"
                      type="email"
                      label="Email address"
                      value={email}
                      onChange={(event) => setEmail(event.target.value)}
                      required
                      disabled={submitting}
                    />
                  </GridItem>
                  <GridItem spanMd="6" spanXLg="4">
                    <Button type="submit" disabled={submitting}>Sign up now</Button>
                  </GridItem>
                </Grid>
                <p className={styles.unsubscribeMessage}>
                  You can unsubscribe at any time using the link in our emails. For more details, review our <SiteLink to="/privacy">privacy policy</SiteLink>.
                </p>
                <RecaptchaAttribution />
              </>
            )}

            {error && <p className={styles.errorMessage}>{error}</p>}
            {showSuccess && (
              <div className={styles.successMessageContainer}>
                <div>
                  <h3>Thank you.</h3>
                  <p>You’ve signed up and will hear from us soon.</p>
                </div>
              </div>
            )}
          </form>

          {/* Submits on our behalf so HubSpot's captcha is satisfied. Kept off-screen
              rather than display:none, which stops reCAPTCHA running. */}
          <div
            id={targetId}
            ref={containerRef}
            className={styles.hiddenEmbed}
            aria-hidden="true"
          />
        </div>
        <div className={styles.circles}>
          <img className={styles.circlesImage} src={CirclesImage} alt="" />
        </div>
      </div>
    </section>
  );
};

export default NewsletterSignupForm;
